import * as Popover from '@radix-ui/react-popover';
import React from 'react';

import PartsItem from '@/components/sections/service/parts/parts-item';
import { ButtonIcon } from '@/components/shared/buttons/button-icon';
import { Icon } from '@/components/shared/element/icons';
import {
  ScrollArea,
  ScrollAreaCorner,
  ScrollAreaScrollbar,
  ScrollAreaThumb,
  ScrollAreaViewport,
} from '@/components/shared/element/scroll-area';
import { keyframes, styled } from '@/stitches.config';
import { IParts } from '@/types/shared/parts';

const slideDown = keyframes({
  '0%': { opacity: 0, transform: 'translateY(-10px)' },
  '100%': { opacity: 1, transform: 'translateY(0)' },
});

const slideUp = keyframes({
  '0%': { opacity: 0, transform: 'translateY(10px)' },
  '100%': { opacity: 1, transform: 'translateY(0)' },
});

const slideLeft = keyframes({
  '0%': { opacity: 0, transform: 'translateX(10px)' },
  '100%': { opacity: 1, transform: 'translateX(0)' },
});

const PopoverContent = styled(Popover.Content, {
  width: '100%',
  maxWidth: 520,
  br: '$rounded-1-5',
  bc: '$white',
  bs: '$shadow-300',
  '--transition-duration': '0.4s, 1s',
  animationDuration: 'var(--transition-duration)',
  animationTimingFunction: 'var(--transition-easing)',
  willChange: 'transform, opacity',
  '&[data-side="top"]': { animationName: slideUp },
  '&[data-side="bottom"]': { animationName: slideDown },
  '&[data-side="right"]': { animationName: slideLeft },
});

const PopoverArrow = styled(Popover.Arrow, {
  fill: 'white',
});

const ImageTrigger = styled('button', {
  position: 'relative',
  all: 'unset',
  cursor: 'pointer',
  br: '100%',
  display: 'inline-block',
  '&::after': {
    content: '""',
    position: 'absolute',
    width: 20,
    height: 48,
    left: 'calc(100% - 8px)',
    top: 'calc(50% - 24px)',
    bc: 'rgba(0, 0, 0, 0)',
    display: 'block',
  },
});

const PartsWrap = styled('div', {
  variants: {
    scrollArea: {
      true: {
        height: 360,
        overflow: 'hidden',
        br: '$rounded-1-5',
      },
    },
  },
});

interface IProps {
  parts: IParts;
  scrollArea?: boolean;
}

const View: React.FunctionComponent<IProps> = (props: IProps) => {
  return (
    <>
      <Popover.Root modal>
        {!!props.parts.keySystemLayout && (
          <Popover.Trigger asChild>
            <ImageTrigger aria-label="button">
              <Icon icon="info" size="xs" color="icon-blue" />
            </ImageTrigger>
          </Popover.Trigger>
        )}
        {props.parts.keySystemLayout ? (
          <PopoverContent sideOffset={8} side="right" avoidCollisions={false}>
            {props.scrollArea ? (
              <PartsWrap scrollArea>
                <ScrollArea type="auto">
                  <ScrollAreaViewport>
                    <PartsItem parts={props.parts} size="small" />
                    <Popover.Close asChild>
                      <ButtonIcon
                        icon="close"
                        variant="button-icon-color-gray-dark"
                        size="md"
                        isTransparent
                        css={{
                          position: 'absolute',
                          right: '$space-1',
                          top: '$space-1',
                        }}
                      />
                    </Popover.Close>
                  </ScrollAreaViewport>
                  <ScrollAreaScrollbar orientation="vertical">
                    <ScrollAreaThumb />
                  </ScrollAreaScrollbar>
                  <ScrollAreaCorner />
                </ScrollArea>
              </PartsWrap>
            ) : (
              <PartsWrap>
                <PartsItem parts={props.parts} size="small" />
                <Popover.Close asChild>
                  <ButtonIcon
                    icon="close"
                    variant="button-icon-color-gray-dark"
                    size="md"
                    isTransparent
                    css={{
                      position: 'absolute',
                      right: '$space-1',
                      top: '$space-1',
                    }}
                  />
                </Popover.Close>
              </PartsWrap>
            )}
            <PopoverArrow />
          </PopoverContent>
        ) : (
          <> {/* Backup PopoverContent */}</>
          // <PopoverContent sideOffset={8} side="right" avoidCollisions={false}>
          //   {props.scrollArea ? (
          //     <PartsWrap scrollArea>
          //       <ScrollArea type="auto">
          //         <ScrollAreaViewport>
          //           <PartsItem parts={props.parts} size="small"></PartsItem>
          //           <Popover.Close asChild>
          //             <ButtonIcon
          //               icon="close"
          //               size="md"
          //               variant="button-icon-color-gray-dark"
          //               isTransparent
          //               css={{ position: 'absolute', right: '$space-1', top: '$space-1' }}
          //             />
          //           </Popover.Close>
          //         </ScrollAreaViewport>
          //         <ScrollAreaScrollbar orientation="vertical">
          //           <ScrollAreaThumb />
          //         </ScrollAreaScrollbar>
          //         <ScrollAreaCorner />
          //       </ScrollArea>
          //     </PartsWrap>
          //   ) : (
          //     <PartsWrap>
          //       <PartsItem parts={props.parts} size="small"></PartsItem>
          //       <Popover.Close asChild>
          //         <ButtonIcon
          //           icon="close"
          //           size="md"
          //           variant="button-icon-color-gray-dark"
          //           isTransparent
          //           css={{ position: 'absolute', right: '$space-1', top: '$space-1' }}
          //         />
          //       </Popover.Close>
          //     </PartsWrap>
          //   )}
          //   <PopoverArrow />
          // </PopoverContent>
        )}
      </Popover.Root>
    </>
  );
};
View.displayName = 'SectionPartsPopHover';
export default View;
